module.exports = __webpack_public_path__ + "media/assets/staffs/qiu_zheng_xian-18513e557e1d030c8bf3f5b9781c372d.jpg";